import CloseIcon from "@shared/svg/close.svg?react";
import React from "react";

interface SheetHeaderProps {
  children: React.ReactNode;
  /** Custom className */
  className?: string;
  /** Optional close button handler */
  onClose?: () => void;
  /** Show close button */
  showCloseButton?: boolean;
}

/**
 * SheetHeader - Header section of the sheet with optional close button
 */
export function SheetHeader({
  children,
  className = "",
  onClose,
  showCloseButton = true,
}: SheetHeaderProps) {
  return (
    <div
      className={`
        bg-primary
        border-0 border-b border-solid border-primary
        flex items-center gap-sm
        px-2xl py-xl
        ${className}
      `}
    >
      <div className="flex-1 min-w-0">{children}</div>

      {showCloseButton && onClose && (
        <button
          type="button"
          onClick={onClose}
          className="
            flex items-center justify-center
            p-sm shrink-0
            bg-primary
            border border-solid border-primary
            rounded-lg
            hover:bg-accent
            transition-colors
          "
          aria-label="Close"
        >
          <CloseIcon className="w-lg h-lg" />
        </button>
      )}
    </div>
  );
}
